module.exports = __webpack_public_path__ + "static/bg-implementation-58b2597a9c360750a2df9376d34e8dac.svg";